import { useContext } from "react";
import { CartContext } from "../context/CartProvider";
import { ShopifyContext } from "../context/ShopifyProvider";

export default function useCart() {
  const { showCart, setShowCart, interactingWithCart } =
    useContext(CartContext);

  // Pull in functions which interact which Shopify Buy SDK
  const {
    updateLineItem,
    addVariantToCart,
    addBundleToCart,
    removeLineItem,
    store: { client, checkout },
  } = useContext(ShopifyContext);

  const checkoutWithShopify = () => {
    return checkout.webUrl;
  };

  //
  const openCart = () => {
    setShowCart(true);
  };

  //
  const closeCart = () => {
    setShowCart(false);
    interactingWithCart.current = false;
  };

  //
  const toggleCart = () => {
    setShowCart((c) => !c);
    if (interactingWithCart.current === true) {
      interactingWithCart.current = false;
    } else {
      interactingWithCart.current = true;
    }
  };

  //
  const openCartWithTimer = (time) => {
    openCart();
    const timer = setTimeout(() => {
      !interactingWithCart.current && closeCart();
    }, time);

    return () => clearTimeout(timer);
  };

  const interactWithCart = () => {
    return (interactingWithCart.current = true);
  };

  //
  const updateCartItemQty = (itemId, qty) => {
    updateLineItem(client, checkout.id, itemId, qty);
  };

  //
  const deleteLineItem = (itemId) => {
    removeLineItem(client, checkout.id, itemId);
  };

  return {
    showCart,
    openCart,
    closeCart,
    toggleCart,
    checkoutWithShopify,
    openCartWithTimer,
    updateCartItemQty,
    interactWithCart,
    deleteLineItem,
    addVariantToCart,
    addBundleToCart,
    checkout,
    lineItems: checkout.lineItems,
    totalPrice: checkout.totalPrice,
  };
}
